/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from 'i18next';
import Check from '@mui/icons-material/Check';
import Folder from '@mui/icons-material/Folder';

import { Typo } from 'uikit/content';
import { Status } from 'uikit/statuses';
import { Breadcrumbs } from 'uikit/layouts';
import { Tooltip } from 'uikit/tooltips';

import styles from '../styles/treeItemSelectorModalContent.module.scss';

const TreeItemSelectorModalContent = ({
  item,
}) => {
  const { data, onItemClick } = item;
  const {
    title, isSource, isDestination, ancestry, isSourceInAncestry, has_editor_permission: hasEditorPermission,
  } = data;

  const isDisabled = isSource || isSourceInAncestry || !hasEditorPermission;

  const breadcrumbs = (ancestry || []).map((ancestor) => ({
    id: ancestor.id,
    text: ancestor.name,
    key: ancestor.id,
  }));

  const shouldUseTooltip = isSource || isSourceInAncestry || !hasEditorPermission;
  let tooltipText = '';

  switch (true) {
    case isSource:
      tooltipText = i18n.t('item-cannot-be-moved-into-itself');
      break;
    case isSourceInAncestry:
      tooltipText = i18n.t('item-cannot-be-moved-into-child');
      break;
    case !hasEditorPermission:
      tooltipText = i18n.t('permissions-tooltip');
      break;
    default:
      break;
  }

  const TitleWrappingElement = shouldUseTooltip ? Tooltip : Fragment;
  const TitleWrappingElementProps = shouldUseTooltip ? {
    content: tooltipText,
    zIndex: 999999,
  } : {};

  return (
    <button
      disabled={isDisabled}
      className={classNames(styles.element, { [styles.isDisabled]: isDisabled })}
      type="button"
      onClick={() => onItemClick({ item })}
    >
      <div className={styles.content}>
        <Folder className={styles.folder} />
        <TitleWrappingElement {...TitleWrappingElementProps}>
          <Typo variant="s03" className={styles.title} title={title}>
            {title}
          </Typo>
        </TitleWrappingElement>
        <Breadcrumbs
          breadcrumbs={breadcrumbs}
          className={styles.breadcrumbs}
          shouldShowAllAsActive={false}
        />
        {isSource && <Status text="Current" variant="info" hasDot={false} className={styles.current} />}
      </div>
      {isDestination && <Check className={styles.check} /> }
    </button>
  );
};

TreeItemSelectorModalContent.propTypes = {
  item: PropTypes.shape({
    data: PropTypes.shape({
      title: PropTypes.string,
      isSource: PropTypes.bool,
      isDestination: PropTypes.bool,
      ancestry: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      })),
      isSourceInAncestry: PropTypes.bool,
    }),
    onItemClick: PropTypes.func,
  }).isRequired,
};

export default React.memo(TreeItemSelectorModalContent);
